const intro = (
  <p>
    Moduł <strong>Egzaminów medycznych</strong> w serwisie Remedium pozwala
    użytkownikom sprawdzać swoją wiedzę medyczną. Aktualnie umożliwiamy
    bezpłatny dostęp do bazy pytań Egzaminu PES, LEK oraz LDEK. Testuj swoją
    wiedzę i śledź postęp, przygotowując się do egzaminów zawodowych z Remedium.
  </p>
);

export const examsDescription = { intro, content: <></> };
